import * as React from "react";
import Panel, { PanelProps } from "./Panel";
import { buildClasses } from "../utils/classes";
import "./TitledPanel.scss";

interface TitledPanelProps extends PanelProps {
  title: string;
  action?: React.ReactNode;
  component?: React.ReactNode;
}

export default function TitledPanel(props: TitledPanelProps) {
  return (
    <Panel {...props}>
      <div
        className={buildClasses(
          {
            fullWidth: props.fullWidth,
            "with-shadow": props.withShadow,
          },
          "react-panel-title"
        )}
      >
        <div className={"react-panel-title-container"}>
          {props.title}
          {props.component}
        </div>
        {props.action && <div className={"react-panel-title-action"}>{props.action}</div>}
      </div>
      {props.children}
    </Panel>
  );
}
